import { createAction } from '@reduxjs/toolkit';
import { createReducerState } from './../sharedConfig/createReducerState';

export const stateAnswersAction = createAction('STATE_TASK_SETS_ACTION');

export const setChartActionAsync = createReducerState({
  options: {},
  property: 'chartCaptures',
  prefix: 'SET_CHART_ACTION',
  initial: false,
});

export const setIdActionAsync = createReducerState({
  options: {},
  property: 'idQuestions',
  prefix: 'SET_ID_ACTION',
  initial: '',
});

export const chartAction = createAction('CHART_ACTION');

export const setFormDataInputsDiagnosticB = createReducerState({
  options: {},
  property: 'formDataInputsDiagnosticB',
  prefix: 'SET_FORM_DATA_INPUTS_DIAGNOSTIC_B',
  initial: false,
});

export const setLoadingChartAction = createReducerState({
  options: {},
  property: 'loadingChart',
  prefix: 'SET_LOADING_CHART',
  initial: false,
});
